import React from 'react';
import moment from 'moment';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import styles from './styles.module.scss';

const CalenderModalAtom = (props) => {
  const { isOpen, toggle } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" className="edit_time_popup">
      <ModalBody>
        <Calendar
          onChange={(val) => props.updateTime(val)}
          value={props.input}
          maxDate={moment().toDate()}
        />
      </ModalBody>
      <ModalFooter className={styles['modal-footer-center']}>
        <button
          className={styles['calendar-btn']}
          onClick={toggle}
        >
          Done
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CalenderModalAtom;
